import React, { useEffect, useState } from 'react';
import { ImageEntity, ImageType } from '../../types';
import { Row, Col } from 'antd';
import Link from 'next/link';
import styles from './Image.module.scss';
import classnames from 'classnames';
import { trim } from 'lodash';

export interface ImageProps extends ImageEntity {
  type?: ImageType;
  className?: any;
  wrapRow?: boolean;
  link?: string;
  ratio?: number;
  captionSize?: 'large' | 'medium' | 'small';
  objectFit?: 'cover' | 'contain';
}

const Image: React.FunctionComponent<ImageProps> = (props: ImageProps) => {
  const [hack, setHack] = useState('');

  useEffect(() => {
    setHack('hack');
  }, []);

  const { Raw, HalfRow, FullRow, ThreeFourth } = ImageType;
  const {
    alt,
    image,
    url,
    caption,
    products = [],
    type = Raw,
    className = styles.img,
    wrapRow = false,
    link = '',
    ratio,
    captionSize = 'large',
    objectFit = 'cover',
  } = props;

  //Check if it's a Strapi media type or our own Image component (caption and Strapi media type)
  const imageUrl = image ? image.url : url;

  // Caption below the image used in Text and Image Blocks which is displayed below the image
  let captionsOutput = null;

  let captionStyle: string;
  switch (captionSize) {
    case 'small':
      captionStyle = styles.captionSmall;
      break;
    case 'medium':
      captionStyle = styles.captionMedium;
      break;
    default:
    case 'large':
      captionStyle = styles.captionLarge;
      break;
  }

  if (caption || !!products?.length) {
    captionsOutput = (
      <div className={classnames(styles.caption, captionStyle)}>
        {caption && (
          <>
            <div className={styles.staticCaption} dangerouslySetInnerHTML={{ __html: caption }} />
            &nbsp;
          </>
        )}
        {!!products.length &&
          products.reduce(
            (acc, product, idx) =>
              acc.concat(
                <Link
                  href={`/products/${
                    product.product_categories?.length
                      ? product.product_categories[0]?.slug
                      : 'category'
                  }/${product.slug}`}
                  as={`/products/${
                    product.product_categories?.length
                      ? product.product_categories[0]?.slug
                      : 'category'
                  }/${product.slug}`}>
                  <a className={styles.productCaption}>{`${trim(product.name)}${
                    idx !== products.length - 1 ? ', ' : ''
                  }`}</a>
                </Link>
              ),
            []
          )}
      </div>
    );
  }

  let imageOutput = (
    <>
      {ratio ? (
        <div
          className={classnames(styles.imageWithRatioContainer, className)}
          style={{
            paddingTop: `${100 / ratio}%`,
          }}>
          <img alt={alt} src={imageUrl} className={styles.imageWithRatio} style={{ objectFit }} />
        </div>
      ) : (
        <img alt={alt} src={imageUrl} className={className} />
      )}

      {captionsOutput}
    </>
  );

  if (link) {
    imageOutput = (
      <Link href={link} as={link}>
        <a rel="noopener noreferrer">{imageOutput}</a>
      </Link>
    );
  }
  // Different types of images based on Wireframe components
  switch (type) {
    case HalfRow:
      imageOutput = (
        <Col xs={{ span: 24, order: 1 }} sm={{ span: 12, order: 2 }}>
          {imageOutput}
        </Col>
      );
      break;
    case ThreeFourth:
      imageOutput = (
        <Col xs={{ span: 24, order: 1 }} sm={{ span: 16, order: 2 }}>
          {imageOutput}
        </Col>
      );
      break;
    case FullRow:
      imageOutput = (
        <Col xs={{ span: 24, order: 1 }} sm={{ span: 24, order: 2 }}>
          {imageOutput}
        </Col>
      );
      break;
    case Raw:
    default:
  }
  if (wrapRow) {
    imageOutput = <Row>{imageOutput}</Row>;
  }
  return <React.Fragment key={`Image-${hack}`}>{imageOutput}</React.Fragment>;
};

export default Image;
